import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import {
  DEFAULT_DEALER_REPORT_RANGE,
  formatPercent,
  trackDealerPerformanceEvent,
} from "../../../constants/automapDealerPerformanceConstants";
import { useDealerPortalIntl } from "../../../hooks/useDealerPortalIntl";
import { fetchDealerInventoryPerformance } from "../../../services/automapDealerPerformanceApi";
import { DealerReportsNav, RecommendedActions, ReportPageHeader, ReportSummaryGrid } from "./DealerPerformanceShared";

export default function DealerInventoryPerformancePage() {
  const { dealerId } = useOutletContext();
  const { t, translateError } = useDealerPortalIntl();
  const [range, setRange] = useState(DEFAULT_DEALER_REPORT_RANGE);
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    trackDealerPerformanceEvent("dealer_inventory_performance_viewed", { dealerId, range });
  }, [dealerId, range]);

  useEffect(() => {
    setLoading(true);
    fetchDealerInventoryPerformance(dealerId, range)
      .then(setPayload)
      .catch((err) => setError(translateError(err.message, "loadReports")))
      .finally(() => setLoading(false));
  }, [dealerId, range]);

  const m = payload?.metrics;

  return (
    <div className="dealer-reports">
      <DealerReportsNav active="inventario" />
      <ReportPageHeader
        title={t("reports.inventoryReport")}
        description={t("reports.inventoryReportDesc")}
        dealerId={dealerId}
        range={range}
        onRangeChange={setRange}
      />
      {loading ? <p className="dealer-state-box">{t("reports.loading")}</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}
      {!loading && !error && m ? (
        <>
          <ReportSummaryGrid
            items={[
              { label: "Activos", value: m.activeListings },
              { label: "Confirmados (7 días)", value: m.confirmedLast7Days },
              { label: "Desactualizados", value: m.staleListings },
              { label: "Calidad promedio", value: m.averageQualityScore ?? "—" },
              { label: "Sin fotos", value: m.missingPhotos },
              { label: "Sin kilometraje", value: m.missingMileage },
              { label: "Alto riesgo", value: m.highRisk },
              { label: "Frescura", value: formatPercent(m.inventoryFreshnessPercent) },
            ]}
          />
          <RecommendedActions actions={payload.recommendedActions} />
          <div className="dashboard-main-grid">
            <section className="dealer-state-box">
              <h3>Publicaciones que necesitan actualización</h3>
              <ul className="dashboard-checklist">
                {(payload.needsAction || []).map((row) => (
                  <li key={row.listingId}>
                    <Link to={`/v/automap/dealer/inventario/${row.listingId}`}>{row.vehicle}</Link>
                  </li>
                ))}
              </ul>
            </section>
            <section className="dealer-state-box">
              <h3>Mejor rendimiento</h3>
              <ul className="dashboard-checklist">
                {(payload.topPerformers || []).map((row) => (
                  <li key={row.listingId}>
                    {row.vehicle} · {row.listingViews} vistas · {row.leads} leads
                  </li>
                ))}
              </ul>
            </section>
            <section className="dealer-state-box">
              <h3>Bajo rendimiento</h3>
              <ul className="dashboard-checklist">
                {(payload.lowPerformers || []).map((row) => (
                  <li key={row.listingId}>{row.vehicle}</li>
                ))}
              </ul>
            </section>
          </div>
        </>
      ) : null}
    </div>
  );
}
